import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

/** Office / reception — Visitors hub + Visitor register (scoped to logged-in user). */
export default function VisitorStaffMetricCards({ loading, dashboardStats }) {
  const stats = dashboardStats || {
    total_visitors: 0,
    today_visitors: 0,
    currently_inside: 0,
    completed_visits: 0,
  };

  const metricItems = [
    {
      key: "total_visitors",
      label: "Total",
      value: stats.total_visitors ?? 0,
      tone: "slate",
      chartHeights: [0.4, 0.55, 0.5, 0.65, 0.75],
    },
    {
      key: "today_visitors",
      label: "Visitors Today",
      value: stats.today_visitors ?? 0,
      tone: "teal",
      chartHeights: [0.38, 0.52, 0.65, 0.55, 0.7],
    },
    {
      key: "currently_inside",
      label: "Currently Inside",
      value: stats.currently_inside ?? 0,
      tone: "slate",
      chartHeights: [0.42, 0.58, 0.48, 0.62, 0.72],
    },
    {
      key: "completed_visits",
      label: "Completed Visits",
      value: stats.completed_visits ?? 0,
      tone: "mint",
      chartHeights: [0.55, 0.62, 0.58, 0.7, 0.78],
    },
  ];

  return (
    <GlobalMetricCards
      items={metricItems}
      loading={loading}
      skeletonCount={4}
      ariaLabel="Visitor summary statistics"
      gridClassName="gm-metrics-grid--quad"
    />
  );
}
